<template>
  <path
    :d="path"
    :style="{
      stroke: serie.colorPrimary,
      strokeWidth: serie.strokeWidth,
      fill: 'none'
    }"
  />
</template>

<script>
import * as d3Shape from "d3-shape";
export default {
  computed: {
    path() {
      var lineFunction = d3Shape
        .line()
        .x(o => {
          return this.p.scaleX(o[this.c.xAxis]);
        })
        .y(o => {
          return this.p.scaleY(o[this.serie.key]);
        })
        .curve(d3Shape[this.c.yAxisCurve]);

      return lineFunction(this.d);
    }
  },
  props: ["p", "c", "d", "serie"]
};
</script>
